
export const API_BASE = window.location.origin;

console.log('🌐 [CONFIG] API_BASE =', API_BASE);
